import LocationDetails from "../components/location/LocationDetails";
import LocationObservations from "../components/location/LocationObservations";
import LocationTrends from "../components/location/LocationTrends";
import LocationAssignments from "../components/location/LocationAssignments";
import LocationEdit from "../components/location/LocationEdit.vue";
import LocationDelete from "../components/location/LocationDelete.vue";

export default [
  {
    name: "LocationDetails",
    path: "/location/:id",
    component: LocationDetails,
    meta: { requiresAuth: false },
    redirect: { name: "LocationObservations" },
    children: [
      {
        path: "observations",
        name: "LocationObservations",
        component: LocationObservations,
      },
      {
        path: "trends",
        name: "LocationTrends",
        component: LocationTrends,
        props: route => ({ locationId: route.params.id })
      },
      {
        path: "assignments",
        name: "LocationAssignments",
        component: LocationAssignments,
        meta: { requiresAuth: true },
      },
      {
        path: "edit",
        name: "LocationEdit",
        component: LocationEdit,
        meta: { requiresAuth: true },
      },
      {
        path: "delete",
        name: "LocationDelete",
        component: LocationDelete,
        meta: { requiresAuth: true },
      },
    ],
  },
];
